<div class="login-supercontainer">
  <div class="login-container">
    <form (submit)="onSubmit()"
          class="form-signin">

      <div class="text-center">
        <img class="capitan-logo-login" src="./assets/images/logo_teal.svg" alt="">
        <p class="capitan-logo-text mb-2">CAPITAN</p>
      </div>

      <ng-container *ngIf="getLoginMode() === LoginMode.emailAndPassword">

        <p class="mb-2"><b>{{ siteName }} Login</b></p>

        <div class="form-group">
          <label for="inputEmail">Email</label>
          <input [(ngModel)]="email"
                 [disabled]="isLoadingSubmit()"
                 [class.disabled]="isLoadingSubmit()"
                 id="inputEmail" name="email"
                 type="email" class="form-control"
                 required autofocus>
        </div>

        <div class="form-group">
          <label for="inputPassword">Password</label>
          <input [(ngModel)]="password"
                 [disabled]="isLoadingSubmit()"
                 [class.disabled]="isLoadingSubmit()"
                 id="inputPassword" name="password"
                 type="password" class="form-control"
                 required>
        </div>

        <div class="form-group" *ngIf="supportPinMode">
          <div class="form-check">
            <input class="form-check-input" type="checkbox"
                   name="usePinMode" id="usePinModeInput"
                   [(ngModel)]="usePinMode"
                   [disabled]="isLoadingSubmit()"
                   [class.disabled]="isLoadingSubmit()">
            <label class="form-check-label" for="usePinModeInput">
              Require PINs when making changes.
            </label>
          </div>
        </div>

        <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>

        <button class="btn btn-lg btn-primary btn-block mb-3" type="submit"
                [disabled]="isLoadingSubmit()">
          {{ isLoadingSubmit() ? 'Loading..' : 'SIGN IN' }}
        </button>

        <p class="text-muted small">
          This login is only for staff members of organizations using Capitan. If you are a climber, go to your facility's website for the appropriate login page.
        </p>

        <p class="mb-0">
          Forgot your password?
          <a href="#"
             (click)="$event.preventDefault();enterPasswordResetMode();">
            Reset it here.
          </a>
        </p>

      </ng-container>

      <ng-container *ngIf="getLoginMode() === LoginMode.otp">

        <p class="mb-2"><b>{{ siteName }} Login</b></p>

        <p>
          Enter a code from your authenticator app to complete login.
        </p>

        <div class="form-group">
          <input type="text" placeholder="XXXXXX"
                 id="otpToken"
                 name="otpToken"
                 class="form-control mb-3"
                 [(ngModel)]="otpToken"
                 [disabled]="isLoadingSubmit()"
                 [class.disabled]="isLoadingSubmit()">
        </div>

        <div class="alert alert-danger" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <button class="btn btn-lg btn-primary btn-block mb-3" type="submit"
                [disabled]="isLoadingSubmit()"
                [class.disabled]="isLoadingSubmit()">
          {{ isLoadingSubmit() ? 'Loading..' : 'SIGN IN' }}
        </button>

        <button class="btn btn-lg btn-secondary btn-block" type="button"
                [disabled]="isLoadingSubmit()"
                [class.disabled]="isLoadingSubmit()"
                (click)="accountService.logout(); errorMessage = '';">
          CANCEL
        </button>

      </ng-container>

      <ng-container *ngIf="getLoginMode() === LoginMode.selectLocation">

        <p class="mb-2"><b>{{ siteName }} Login</b></p>

        <div class="form-group">
          <label for="selectLocation">Location</label>
          <select class="custom-select" id="selectLocation" name="selectLocation"
                  [(ngModel)]="selectedLocationId"
                  [disabled]="loadingSelectLocationData() || isLoadingSubmit()"
                  [class.disabled]="loadingSelectLocationData() || isLoadingSubmit()">
            <option *ngIf="loadingSelectLocationData()">
              Loading...
            </option>
            <ng-container *ngIf="!loadingSelectLocationData()">
              <option *ngFor="let location of locationService.getLocations()"
                      [ngValue]="location.id">
                {{ location.name }}
              </option>
            </ng-container>
          </select>
        </div>

        <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>

        <button class="btn btn-lg btn-primary btn-block" type="submit"
                [disabled]="loadingSelectLocationData() || isLoadingSubmit()">
          {{ isLoadingSubmit() ? 'Loading..' : 'CONTINUE' }}
        </button>

      </ng-container>

      <ng-container *ngIf="getLoginMode() === LoginMode.resetPassword">

        <p class="mb-2"><b>Reset Password</b></p>

        <ng-container *ngIf="passwordResetSuccess">

          <div class="alert alert-success">
            Reset request submitted successfully.
          </div>

        </ng-container>

        <ng-container *ngIf="!passwordResetSuccess">

          <p class="small">
            Enter the email associated with your Capitan Staff Site account and we'll send you instructions to reset your password, if an account matches that email.
          </p>

          <div class="form-group">
            <label for="inputEmailPasswordReset">Email</label>
            <input [(ngModel)]="email"
                   [disabled]="isLoadingSubmit()"
                   [class.disabled]="isLoadingSubmit()"
                   id="inputEmailPasswordReset"
                   name="email"
                   type="email" class="form-control"
                   required autofocus>
          </div>

          <p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>

          <button class="btn btn-lg btn-primary btn-block mb-3" type="submit"
                  [disabled]="isLoadingSubmit() || (email == '')"
                  [class.disabled]="isLoadingSubmit() || (email == '')">
            {{ isLoadingSubmit() ? 'Loading..' : 'Reset Password' }}
          </button>

        </ng-container>

        <button class="btn btn-lg btn-secondary btn-block" type="button"
                [disabled]="isLoadingSubmit()"
                [class.disabled]="isLoadingSubmit()"
                (click)="exitPasswordResetMode()">
          Return to Login
        </button>

      </ng-container>

    </form>
  </div>
</div>
